import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useCallback } from 'react'
import { useCheckHealthCardExpiry } from '../../queries/useCheckHealthCardExpiry'
import { useGetPatientProfileData } from '../../queries/useGetPatientProfileData'

export const useHealthCardExpiryCheck = () => {
  const {
    mutateAsync: checkHealthCardExpiry,
    isLoading: loadingCheckHealthCardExpiry,
  } = useCheckHealthCardExpiry()
  const { showModal } = useModalContext()
  const { mutateAsync: getUserData, isLoading: loadingGetUserData } =
    useGetPatientProfileData()

  const busyHealthCardExpiryCheck =
    loadingCheckHealthCardExpiry || loadingGetUserData

  const checkPatientEligibility = useCallback(async () => {
    try {
      const userData = await getUserData()

      const result = await checkHealthCardExpiry({
        healthPlanCard: userData?.user?.patient?.healthInsuranceNumber,
      })
      return result
    } catch (error) {
      return false
    }
  }, [checkHealthCardExpiry, getUserData])

  const showUpdateHealthCardModal = useCallback(() => {
    showModal('HEALTH_PLAN_CARD', {
      title: 'Atualize sua carteirinha',
      width: 480,
    })
  }, [showModal])

  return {
    showUpdateHealthCardModal,
    checkPatientEligibility,
    busyHealthCardExpiryCheck,
  }
}
